/** Screen context shared by every event sent from the Poland-wide apartment prices page. */
export const PRICES_HUB_ANALYTICS_LOCATION = "rp_apartment_prices_country";

export const PRICES_HUB_OFFERS_LIST_NAME = "Najniższa cena za m² – polecane oferty";
/** Screen context shared by every event sent from the Poland-wide apartment prices page. */
export const PRICES_HUB_ANALYTICS_LOCATION = "rp_apartment_prices_country";

export const PRICES_HUB_OFFERS_LIST_NAME = "Najniższa cena za m² – polecane oferty";
